import { render, staticRenderFns } from "./EagleTap.vue?vue&type=template&id=18ec7004&scoped=true&"
import script from "./EagleTap.vue?vue&type=script&lang=js&"
export * from "./EagleTap.vue?vue&type=script&lang=js&"
import style0 from "./EagleTap.vue?vue&type=style&index=0&id=18ec7004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ec7004",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18ec7004')) {
      api.createRecord('18ec7004', component.options)
    } else {
      api.reload('18ec7004', component.options)
    }
    module.hot.accept("./EagleTap.vue?vue&type=template&id=18ec7004&scoped=true&", function () {
      api.rerender('18ec7004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_marginnote_landing/components/AppSale/EagleTap.vue"
export default component.exports